// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import snackbarReducer from './slices/snackbar';
import customerReducer from './slices/customer';
import contactReducer from './slices/contact';
import productReducer from './slices/product';
import chatReducer from './slices/chat';
import calendarReducer from './slices/calendar';
import mailReducer from './slices/mail';
import userReducer from './slices/user';
import dataReducer from './slices/data';
import kanbanReducer from './slices/kanban';
import menuReducer from './slices/menu';
import settingsReducer from './slices/settings';
import learnerReducer from './slices/learner';
import coursesReducer from './slices/courses';
import resourcesReducer from './slices/resource';
import analyticsReducer from './slices/analytics';
import logsReducer from './slices/logs';
import notificationsReducer from './slices/notifications';
import backdropReducer from './slices/backdrop';
import apiUserReducer from './slices/api-user';
import synchronisationlogReducer from './slices/synchronisationlogs';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    data: persistReducer(
        {
            key: 'data',
            storage,
            keyPrefix: 'lln-robot-'
        },
        dataReducer
    ),
    kanban: kanbanReducer,
    customer: customerReducer,
    contact: contactReducer,
    product: productReducer,
    chat: chatReducer,
    calendar: calendarReducer,
    mail: mailReducer,
    user: userReducer,
    menu: menuReducer,
    settings: settingsReducer,
    learner: learnerReducer,
    courses: coursesReducer,
    resource: resourcesReducer,
    analytic: analyticsReducer,
    logs: logsReducer,
    notifications: notificationsReducer,
    backdrop: backdropReducer,
    apiuser: apiUserReducer,
    synchronisationlog: synchronisationlogReducer
});

export default reducer;
